import { render, staticRenderFns } from "./SourcesForm.vue?vue&type=template&id=33257fea&scoped=true"
import script from "./SourcesForm.vue?vue&type=script&lang=js"
export * from "./SourcesForm.vue?vue&type=script&lang=js"
import style0 from "./SourcesForm.vue?vue&type=style&index=0&id=33257fea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33257fea",
  null
  
)

export default component.exports